export enum StatusGroupType {
  NotStarted = 'not_started',
  Active = 'active',
  Completed = 'completed',
  Closed = 'closed',
  Other = 'other',
}
